import { Box, Button, DialogActions, Typography } from '@mui/material';
import React from 'react';
import IconSuccess from '../../assets/icon-success.svg';
import DefaultModal from './DefaultModal';

interface Props {
  open: boolean;
  handleClose: () => void;
  message?: string;
  children?: React.ReactNode;
}

const SuccessModal = (props: Props): JSX.Element => {
  return (
    <DefaultModal open={props.open} handleClose={props.handleClose}>
      <Box sx={{ px: 6, pb: 6 }}>
        <Box textAlign="center" mb={3}>
          <img src={IconSuccess} alt="success" />
        </Box>
        <Typography variant="h3" textAlign="center" color="grey.900" mb={2}>
          Success!
        </Typography>
        {props.message && (
          <Typography textAlign="center">{props.message}</Typography>
        )}
        {props.children}
      </Box>
      <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
        <Button onClick={props.handleClose} sx={{ width: '200px' }}>
          Close
        </Button>
      </DialogActions>
    </DefaultModal>
  );
};

export default SuccessModal;
